export default __webpack_public_path__ + "images/cereal_labeled-OGGDz.png";